var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.13618e-07 0.187484L-4.62393e-07 1.35936C-4.5891e-07 1.43905 0.0390621 1.51405 0.103125 1.56092L6.22187 5.99998L0.103125 10.439C0.0390625 10.4859 -6.01801e-08 10.5609 -5.66969e-08 10.6406L-5.47257e-09 11.8125C-1.03314e-09 11.914 0.115625 11.9734 0.198438 11.914L7.79375 6.40467C8.06875 6.20467 8.06875 5.7953 7.79375 5.59686L0.198437 0.0874834C0.115625 0.0265455 -5.18057e-07 0.0859213 -5.13618e-07 0.187484Z",
    fill: "#8C8C8C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.0a72b8923340c0cf59f93e2e3dbc5bef.svg";
export { ForwardRef as ReactComponent };